import React, { useEffect, useMemo, useState } from "react";
import { RowFlex, Add, ModalDesign } from "./style";
import Button from "../../../components/FormElement/Button";
import ProjectCard from "../../../components/Cards/VacancyCard";
import { PlusOutlined } from "@ant-design/icons";
import { useHideModal, useShowModal } from "../../../hooks";
import Tab from "../../../components/Tab";
import service from "../../../services/vacancy";
import Pagination from "../../../components/FormElement/Pagination";
import Form from "./Form";
import DeleteModal from "../../../components/Achive";
import Spinner from "../../../components/Spinner/FullScreen";
import { useShowAlert } from "../../../hooks/useAlerts";
import { textareaToArray } from "../../../utils/textareaToArray";

function Vacancy() {
  const [selectedCategory, setSelectedCategory] = useState("true");
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const categoryQuery = useMemo(
    () => (selectedCategory ? `&active=${selectedCategory}` : ""),
    [selectedCategory]
  );
  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : ""),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}${categoryQuery}`,
    [pageQuery, limitQuery, categoryQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result?.rows.map((item) => ({
        ...item,
        title: item?.title,
      }));
      setData(finalResult);
      setTotal(result?.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [query]);

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };
  const handleDelete = (id) => {
    if (id) {
      showBlured({
        title: "",
        maxWidth: "400px",
        maxHeight: "500px",
        withHeader: false,
        body: () => <DeleteModal onClick={() => handleDel(id)} />,
      });
    }
  };

  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const options = useMemo(
    () => [
      { key: "true", label: "Yangi" },
      { key: "false", label: "Arxiv" },
    ],
    [selectedCategory]
  );

  const changeTab = (key) => {
    setPagination((prev) => ({ ...prev, page: 1 }));
    setSelectedCategory(key);
  };

  const handleEdit = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "1000px",
      maxHeight: "75vh",
      withHeader: false,
      body: () => <Form fetch={fetchData} edit={data?.id} />,
    });
  };

  const handleShowModal = () => {
    showBlured({
      title: "Vakansiya yarating",
      maxWidth: "1000px",
      maxHeight: "75vh",
      withHeader: false,
      body: () => <Form fetch={fetchData} />,
    });
  };

  const handleClick = (data) => {
    showBlured({
      title: "UX/UI dizayn vakansiya",
      maxWidth: "600px",
      maxHeight: "70vh",
      withHeader: false,
      body: () => (
        <ModalDesign>
          <div>
            <h3 className="title">Talablar</h3>
            <ul>
              {textareaToArray(data?.requirements?.[0] || '')?.map((item, i) => (
                <li className="desc" key={i}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="title">Shartlar</h3>
            <ul>
              {textareaToArray(data?.conditions?.[0] || '')?.map((item, i) => (
                <li className="desc" key={i}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="title">Vazifalar</h3>
            <ul>
              {textareaToArray(data?.tasks?.[0] || '')?.map((item, i) => (
                <li className="desc" key={i}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </ModalDesign>
      ),
    });
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <Add>
        <Tab
          tabs={options}
          defaultCurrent={selectedCategory}
          onChange={(key) => changeTab(key)}
        />
        <Button
          text="Qo'shish"
          icon={<PlusOutlined />}
          onClick={handleShowModal}
        />
      </Add>

      <RowFlex>
        {data.map((item) => (
          <div className="card" key={item.id}>
            <ProjectCard
              data={item}
              onAchive={handleDelete}
              onEdit={handleEdit}
              onclick={() => handleClick(item)}
              rezume
              achive
              noaction={selectedCategory == "true" ? false : true}
            />
          </div>
        ))}
      </RowFlex>
      {total > 10 && (
        <Pagination
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </div>
  );
}

export default Vacancy;
